@use "../../sass/global/global" as *;

$default-card-background-color: #fff;
$default-card-padding: 30px;
$default-card-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.09);

/**
@prop --card-background-color: Background color of the card (default `#fff`)
@prop --card-padding: Inner padding of the card content area (default `30px`)
@prop --card-shadow: Drop shadow of the card (default `0 5px 25px 0 rgba(0, 0, 0, 0.09)`)
 */
:host {
    display: block;
    background-color: var(
        --card-background-color,
        $default-card-background-color
    );
    box-shadow: var(--card-shadow, $default-card-shadow);
    width: 100%;
    height: 100%;
}

.grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr auto;
    grid-template-areas:
        "image"
        "content"
        "cta";
    position: relative;
    width: 100%;
    height: 100%;
}

:host([layout="horizontal"]) {
    .grid {
        grid-template-columns: auto 1fr;
        grid-template-rows: 1fr auto;
        grid-template-areas:
            "image content"
            "image cta";
    }
}

.image,
.content,
.cta {
    display: block;
    width: 100%;
    box-sizing: border-box;
}

.image {
    grid-area: image;
}

.content {
    grid-area: content;
}

.cta {
    grid-area: cta;
    padding-left: var(--card-padding, $default-card-padding);
    padding-right: var(--card-padding, $default-card-padding);
    padding-bottom: var(--card-padding, $default-card-padding);
}

.is-hidden {
    display: none;
}
